{
  "conversation": {
    "agent_mode": {
      "saved": "Perfil guardado",
      "agents": {
        "kaila": {
          "name": "Jura",
          "description": "Asistente jurídico"
        },
        "kfc": {
          "name": "Gestor de casos",
          "description": "Esta conversación se basa en el perfil del gestor de casos. Los documentos cargados por la municipalidad se utilizan en las respuestas."
        },
        "replay": {
          "name": "Reproducir",
          "description": "Reproducir conversaciones anteriores"
        },
        "mock": {
          "name": "Mock",
          "description": "Agente simulado"
        }
      }
    },
    "ask_kaila_back": {
      "submit_button": "Responder",
      "user_selected": "He seleccionado las siguientes opciones:",
      "mode_question": "Pregunta",
      "mode_suggestion": "Sugerencia",
      "switch_mode": "Haz una investigación profunda",
      "keep_previous_mode": "Mantén la respuesta {{previous}}",
      "about_deep": "Una investigación profunda puede darte una respuesta más completa",
      "deep_description": "Una investigación profunda revisa la legislación, la jurisprudencia y fuentes relacionadas antes de responder, para que puedas obtener más contexto y referencias.",
      "kfc_title": "¿En qué áreas debería centrarme?",
      "kfc_description": "He identificado las siguientes áreas que podrían ser relevantes para su pregunta. Seleccione todas las que correspondan.",
      "skip": "Omitir"
    },
    "references_panel": {
      "empty_state": "No hay fuentes para esta respuesta.",
      "source_validation": {
        "button": "Mostrar",
        "toggle_type": "tipo",
        "toggle_name": "título"
      },
      "error": {
        "title": "Se produjo un error",
        "description": "Se produjo un error al cargar las fuentes"
      },
      "go_to_document": "Ir al documento",
      "header": "Fuentes",
      "no_content_disclaimer": "Vista previa no disponible",
      "open_in_karnov": "Abrir en Aranzadi LA LEY",
      "ai_generated_summary": {
        "text": "Resumen de Allegra",
        "tooltip": "Ofrecemos la jurisprudencia resumida con IA para preservar la precisión del contexto."
      }
    },
    "annotation_type": {
      "karnov": "Notas de Aranzadi LA LEY",
      "lexino": "",
      "nj_annotation": ""
    },
    "conversation_error": {
      "title": "Algo salió mal",
      "description": "Algo salió mal con la conversación. Intenta recargar la página o contacta con el servicio de atención al cliente.",
      "guide": "Ayúdanos a solucionar el problema compartiendo el contenido de la conversación.",
      "send_to_support": "Comparte la conversación con nosotros",
      "success_title": "Informe de error enviado",
      "success_message": "Gracias, tu informe de error ha sido enviado"
    },
    "conversation_feedback": {
      "cancel": "Omitir",
      "confirmation": "Gracias por compartir tus comentarios",
      "conversation_rating_question": "Explica tu valoración",
      "description": "Selecciona la categoría que mejor se ajuste a tus opiniones. Tus comentarios nos ayudan a mejorar nuestras respuestas. Al enviar comentarios, consientes que revisemos tu opinión, la conversación completa (preguntas y respuestas), las fuentes referenciadas y los archivos adjuntos.",
      "error": "Algo salió mal, inténtalo de nuevo",
      "feedback_modal": "Queremos tu opinión",
      "consent_checkbox": "Doy mi consentimiento para que contacten conmigo si se necesita más información.",
      "options": {
        "1": {
          "title": "Alucinación (hechos falsos, fuentes incorrectas, etc.)",
          "placeholder": "La respuesta contiene referencias inventadas o conclusiones sin fuentes jurídicas válidas que la respalden."
        },
        "2": {
          "title": "Problema con la relevancia o pertinencia legal de la respuesta",
          "placeholder": "La respuesta se basa en fuentes jurídicas derogadas o carece de referencias a fuentes jurídicas relevantes. Indica la(s) fuente(s) que falta(n)"
        },
        "3": {
          "title": "Respuesta poco clara o imprecisa",
          "placeholder": "La respuesta es ambigua o carece de detalles relevantes"
        },
        "4": {
          "title": "Problema con el contexto o interpretación (aplicable también a sugerencias/respuestas a preguntas adicionales)",
          "placeholder": "Mala interpretación de la pregunta formulada"
        },
        "5": {
          "title": "Problema con las fuentes (desactualizadas, mal interpretadas, etc.)",
          "placeholder": "La respuesta no incluye las fuentes jurídicas más recientes o hace una mala interpretación de las fuentes jurídicas"
        },
        "6": {
          "title": "Otro",
          "placeholder": "¿Tuviste otros problemas con la respuesta? Cuéntanos"
        }
      },
      "submit": "Enviar comentarios",
      "textarea_placeholder": "Por favor, detalla...",
      "title": "Gracias por compartir tus comentarios"
    },
    "conversation_sources": "Fuentes utilizadas",
    "prompt_templates": {
      "create_title": "Guardar nuevo prompt",
      "create_description": "Guarda prompts para usarlos más tarde. Te puede resultar útil para tareas o preguntas que repites con frecuencia o que sueles empezar de la misma manera.",
      "edit_title": "Editar prompt",
      "title_label": "Título",
      "title_placeholder": "",
      "content_label": "Tu prompt",
      "content_placeholder": "",
      "save": "Guardar",
      "cancel": "Cancelar",
      "delete": "Eliminar",
      "save_success": "Prompt guardado",
      "save_error": "No se pudo guardar el prompt",
      "validation_error": "Revisa el título y el prompt e inténtalo de nuevo",
      "delete_success": "Prompt eliminado",
      "delete_error": "No se pudo eliminar el prompt",
      "delete_confirm": {
        "title": "Eliminar prompt",
        "question": "¿Confirmas que quieres eliminar este prompt?",
        "confirm": "Eliminar",
        "cancel": "Cancelar"
      },
      "title": "Prompts guardados",
      "description": "Si sueles hacer las mismas preguntas o reutilizar el mismo contexto, guarda aquí tus prompts para volver a usarlos con un solo clic cuando los necesites.",
      "new_prompt": "Nuevo prompt",
      "search_placeholder": "Buscar prompts...",
      "search_aria": "Buscar en los prompts guardados",
      "search_clear": "Borrar búsqueda",
      "see_details": "Ver detalles",
      "close_details": "Ocultar detalles",
      "edit": "Editar",
      "edit_prompt_aria": "Editar prompt: {{title}}",
      "trigger_label": "Prompts",
      "trigger_tooltip": "Abrir prompts guardados",
      "no_results": "No hay resultados",
      "close": "Cerrar prompts guardados",
      "delete_prompt_aria": "Eliminar prompt: {{title}}",
      "error": {
        "title": "Se produjo un error",
        "description": "Se produjo un error al cargar los prompts guardados"
      },
      "pagination": "Paginación",
      "pagination_previous": "Anterior",
      "pagination_next": "Siguiente",
      "pagination_previous_aria": "Ir a la página anterior",
      "pagination_next_aria": "Ir a la página siguiente",
      "pagination_page_aria": "Ir a la página {{page}}",
      "attachment_warning": "Los archivos subidos y los etiquetados aún no se pueden guardar junto con los prompts.",
      "suggest": "Sugiere",
      "generating_title": "Generando título",
      "title_error": "No se pudo generar un título."
    },
    "message_done_toast": "Tu conversación ha finalizado. Haz clic aquí para ir a la conversación",
    "message_done_toast_with_subject": "Tu conversación \"{{subject}}\" ha finalizado. Haz clic aquí para ir a la conversación",
    "error": {
      "no_access": {
        "description": "Selecciona otra conversación o inicia una nueva desde el menú",
        "title": "No tienes acceso a esta conversación"
      },
      "not_found": {
        "description": "Selecciona otra conversación o inicia una nueva desde el menú",
        "title": "Conversación no encontrada"
      },
      "unknown": {
        "description": "Intenta recargar la página",
        "title": "No se puede recuperar tu conversación en este momento"
      }
    },
    "message_action": {
      "cancel_edit_message": "Cancelar edición",
      "copy_message": "Copiar",
      "delete_failed_user_message": "Eliminar",
      "downvote_message": "No me gusta",
      "upvote_message": "Me gusta",
      "edit_message": "Editar pregunta",
      "edit": "Editar",
      "export_docx": "Exportar a Word",
      "export": "Exportar",
      "more_actions": "Más acciones",
      "print_message": "Imprimir",
      "regenerate_message": "Generar respuesta de nuevo",
      "save_message": "Guardar mensaje",
      "save": "Guardar",
      "skip_to_content": "Volver al inicio del mensaje",
      "to_top": "Inicio del mensaje"
    },
    "export_docx": {
      "success": "El documento se ha exportado correctamente",
      "error": "No se ha podido exportar el documento",
      "question_heading": "Pregunta",
      "answer_heading": "Respuesta"
    },
    "prompt_input": {
      "disclaimer_text": "",
      "disclaimer_link": {
        "prefix": "Nuestra IA complementa, pero no sustituye, el trabajo humano. Más información en\u00A0",
        "text": "nuestra web",
        "suffix": ".",
        "href": "https://www.aranzadilaley.es/declaracion-uso-IA.html"
      },
      "placeholder": "Escribe tu consulta",
      "placeholder_follow_up": "Escribe una pregunta para continuar la conversación",
      "document_tag": "Etiqueta un documento"
    },
    "document_tagging": {
      "placeholder": "Escribe el título o marginal del documento",
      "prompt_input_suggestion": "Referenciar documento",
      "clear_input": "Borrar texto de búsqueda",
      "finding_documents": "Buscando documentos...",
      "search_for_documents_title": "Busca un documento en Aranzadi LA LEY",
      "search_for_documents_description": "Indica el título o marginal del documento",
      "no_documents_found_title": "No se encontraron documentos",
      "no_documents_found_description": "Escribe un título o referencia válido, o ve a Aranzadi LA LEY para encontrar el documento.",
      "kfc_disclaimer": "Allegra ya tiene acceso a tus documentos locales, por lo que no es necesario etiquetarlos.",
      "error_title": "Algo salió mal",
      "error_description": "Intenta recargar la página",
      "title": "Resultados"
    },
    "prompt_button": {
      "label": "Pregunta a Allegra",
      "stop": "Cancelar"
    },
    "research_mode": {
      "light": {
        "name": "Investigación rápida",
        "short": "Rápida",
        "description": "Para consultas rápidas. Consulta un conjunto limitado de fuentes; no realiza un análisis exhaustivo."
      },
      "regular": {
        "name": "Investigación regular",
        "short": "Estándar",
        "description": "Busca en todas las fuentes de Karnov y elabora una respuesta estructurada."
      },
      "deep": {
        "name": "Investigación profunda",
        "short": "Exhaustiva",
        "description": "Realiza una búsqueda minuciosa para consultas complejas. Requiere más tiempo."
      }
    },
    "user_message": {
      "cancel_button": "Cancelar",
      "submit_button": "Guardar y Enviar"
    },
    "table_view": {
      "close_button": "Cerrar pantalla completa",
      "modal_title": "Tabla en tamaño completo",
      "open_button": "Abrir en tamaño completo"
    },
    "loading_header": {
      "estimated_time": "Tiempo estimado de espera",
      "less_than_a_minute": "Menos de un minuto",
      "minutes_one": "{{count}} minuto",
      "minutes_other": "{{count}} minutos",
      "slow_answer_disclaimer": "Generando una respuesta compleja. Este proceso puede tardar un poco más de lo habitual."
    },
    "clipboard": {
      "copy_success": "Contenido copiado",
      "copy_error": "Error al copiar el contenido"
    }
  },
  "conversation_history": {
    "load_more_button": "Cargar más",
    "load_more_title": "Mostrando página {{currentPage}} de {{totalPages}}",
    "no_more_conversations": "Has llegado al final de tu historial de conversaciones.",
    "go_to_top": "Ir al inicio de la lista",
    "close_conversation_history_panel": "Ocultar historial",
    "close_conversation_sidepanel": "Cerrar panel lateral",
    "conversation_expiration_one": "{{count}} día",
    "conversation_expiration_other": "{{count}} días",
    "conversation_expiration_tooltip_one": "Se eliminará en 1 día a menos que interactúes para mantenerla activa.",
    "conversation_expiration_tooltip_other": "Se eliminará en {{count}} días a menos que interactúes para mantenerla activa.",
    "conversation_expiration_expired_tooltip": "Tus conversaciones se guardan durante 90 días después de la última actividad. Luego se eliminarán automáticamente.",
    "conversation_action": {
      "delete": "Eliminar conversación",
      "pin": "Anclar conversación",
      "rename": "Editar título",
      "unpin": "Desanclar"
    },
    "conversation_delete_modal": {
      "cancel_button": "Cancelar",
      "delete_button": "Eliminar",
      "title": "Eliminar conversación",
      "question": "¿Estás seguro de que deseas eliminar la conversación?"
    },
    "error": {
      "description": "Intenta recargar la página",
      "title": "No se puede recuperar tu historial en este momento"
    },
    "expired_conversations_onboarding": "Para proteger tus datos, las conversaciones inactivas por más de 90 días se eliminarán permanentemente a partir de ahora.",
    "history": "Historial",
    "history_expiration_time": "90 días",
    "history_short": "Histórico",
    "history_tooltip": "Tus conversaciones se guardan durante 90 días después de la última actividad. Luego se eliminarán automáticamente.",
    "new_conversation_button": "Nueva conversación",
    "new_conversation_button_short": "Nueva",
    "new_conversation_subject": "Nueva conversación",
    "new_document_analysis_button": "Análisis de documentos",
    "new_document_analysis_button_beta_label": "BETA",
    "new_document_analysis_button_new_label": "Nuevo",
    "new_document_analysis_button_short": "Análisis",
    "flow_access_link": "Allegra Flow",
    "flow_access_link_short": "Flow",
    "open_conversation_history_panel": "Mostrar historial",
    "open_conversation_sidepanel": "Abrir panel lateral",
    "panel_header": "Menú",
    "pinned": "Conversaciones ancladas",
    "edit_conversation_subject_submit": "Guardar cambios en el tema de la conversación",
    "edit_conversation_subject_cancel": "Cancelar cambios en el tema de la conversación",
    "search_in_conversation": "Busca en tu historial",
    "search_in_conversation_description": "Busca en las conversaciones por tema",
    "search_in_conversation_clear": "Borrar búsqueda",
    "empty_search_in_conversation": "No se encontraron conversaciones con la búsqueda: \"{{searchTerm}}\"",
    "toast_notification": {
      "conversation_pinned_error": "Error al anclar la conversación",
      "conversation_unpinned_error": "Error al desanclar la conversación",
      "conversation_pinned_successful": "Conversación anclada",
      "conversation_unpinned_successful": "Conversación desanclada",
      "conversation_delete_success": "Conversación eliminada",
      "conversation_delete_error": "No se eliminó la conversación",
      "subject_editting_error": "No se pudieron realizar los cambios",
      "subject_editting_sucessful": "Cambios realizados"
    },
    "today": "Hoy",
    "yesterday": "Ayer",
    "latest_7_days": "Últimos 7 días",
    "latest_15_days": "Últimos 15 días",
    "latest_30_days": "Últimos 30 días",
    "latest_60_days": "Últimos 60 días",
    "more_than_60_days": "Más de 60 días - Se eliminarán pronto",
    "expired": "Expira pronto",
    "retention_info": "Tus conversaciones se guardan durante 90 días después de la ultima actividad. Luego se eliminarán automáticamente."
  },
  "file_upload": {
    "capacity_usage": "{{space}} % de espacio usado",
    "content_type": {
      "application/pdf": "Pdf",
      "application/msword": "Word",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "Word",
      "unknown": "Desconocido",
      "unsupported": "Tipo de archivo no compatible"
    },
    "drag_and_drop_label_one": "Sube un documento para que Allegra lo utilice en esta conversación",
    "drag_and_drop_label_other": "Sube documentos para que Allegra los utilice en esta conversación",
    "file_upload_limit_exceeded": "Has seleccionado demasiados documentos.",
    "file_upload_limit_reached": "No puedes subir más documentos.",
    "header": "Arrastra y suelta aquí tu documento",
    "subheader": "Formatos aceptados: Word (.docx) o pdf. Tamaño máximo: 20 MB. Máximo 400 páginas.",
    "upload_button": "Sube un documento",
    "upload_status": {
      "error": "Error",
      "uploading": "Subiendo",
      "deleting": "Eliminando"
    },
    "error": {
      "above_page_count_limit": "Los archivos no deben contener más de 400 páginas.",
      "above_word_count_limit": "Los archivos no deben contener más de 100 000 palabras",
      "above_file_size_limit": "Los archivos no deben superar los 20 MB.",
      "content_too_large": "Los archivos no deben superar los 20 MB.",
      "malformed_file_content": "El archivo no se pudo leer - puede estar dañado",
      "deletion_error": "Ocurrió un error al eliminar el archivo.",
      "invalid_mime_type": "Este tipo de archivo no es compatible. Solo puedes subir archivos Word (.docx) y PDF.",
      "exceeds_token_limit": "Este documento supera el límite de espacio y no se utilizará.",
      "upload_error": "Ocurrió un error al subir el archivo.",
      "virus_detected": "El archivo cargado parece contener un virus."
    }
  },
  "frequently_asked_questions": {
    "footer": {
      "customer_service": "Atención al cliente",
      "customer_service_url": "https://areacliente.aranzadilaley.es/",
      "terms": "Términos y condiciones",
      "terms_url": "https://www.aranzadilaley.es/declaracion-uso-IA.html"
    },
    "help": "Ayuda",
    "helpful_question_answer_title": "¿Esto respondió a tu pregunta?",
    "helpful_question_answer_button_yes": "Sí",
    "helpful_question_answer_button_no": "No",
    "thank_you_for_feedback_description": "Tu opinión ayuda a mejorar esta información para todos.",
    "thank_you_for_feedback_title": "¡Gracias por tus comentarios!",
    "thank_you_for_feedback_toast_notification": "Gracias por tus comentarios",
    "related_questions": "Preguntas relacionadas"
  },
  "help_and_feedback": {
    "button": "Ayuda y comentarios",
    "dropdown_options": {
      "help": "Ayuda",
      "tutorial": "Guía",
      "user_carousel_onboarding": "Introducción"
    }
  },
  "kfc": {
    "description": "La primera respuesta se basa en fuentes de la base de datos de Aranzadi LA LEY, mientras que esta respuesta adicional se basa en los documentos internos de tu municipio, siempre que hayan sido subidos y estén disponibles en Aranzadi LA LEY. Ambas respuestas incluyen referencias y enlaces a las fuentes utilizadas."
  },
  "message": {
    "create_conversation_message_error": "No se pudo enviar.",
    "create_conversation_message_retry": "Inténtalo de nuevo",
    "streaming_waiting": "Esperando respuesta",
    "streaming_canceled": "Respuesta detenida",
    "streaming_error": "Ocurrió un error al generar la respuesta",
    "streaming_error_retry": "Generar de nuevo",
    "streaming_error_code": "Código de error",
    "streaming_error_conversation": "Conversación",
    "streaming_reconnect_error": "Ocurrió un error al intentar restablecer la conexión",
    "streaming_reconnect_error_retry": "Intenta restablecer la conexión",
    "thoughts": "Razonamiento de la respuesta",
    "follow_up": "También puedes preguntar",
    "follow_up_description": "Continúa con la conversación",
    "updated_at": "{{updatedAt, date}}"
  },
  "no_access": {
    "title": "No tienes acceso a este contenido",
    "description": "Este contenido requiere acceso a un producto o suscripción específicos que no están incluidos en tu plan actual.",
    "refresh_access": {
      "button": "Actualizar el acceso",
      "description": "Si crees que se trata de un error, prueba a actualizar tus ajustes de acceso. Esta acción debería actualizar tu suscripción y desbloquear todo el contenido al que tienes acceso.",
      "contact_support": "Si el problema persiste, ponte en contacto con nuestro equipo de atención al cliente, cuyos datos figuran a continuación. Estarán encantados de ayudarte."
    },
    "contact_info": {
      "header": "Estamos listos para ayudarte",
      "description": "",
      "link": {
        "prefix": "Contacta con",
        "text": "nuestro servicio de atención al cliente",
        "suffix": "y te atenderemos.",
        "href": "https://areacliente.aranzadilaley.es/solicitud_alta_area_cliente?tipo=nosuscriptor&_gl=1*1rffq0i*_gcl_aw*R0NMLjE3NzEzMjY0ODYuRUFJYUlRb2JDaE1JNV9DbnFMSGdrZ01WbllCUUJoMzFvUnZpRUFBWUFTQUFFZ0tTVlBEX0J3RQ..*_gcl_au*MzY0NjQxMjY3LjE3NzA3Mjg1MDk.*_ga*MTg0NTU3NDAxLjE3NzA3MTAxNzQ.*_ga_P55YSR6Z3D*czE3NzI1MzA1NzQkbzIwJGcxJHQxNzcyNTMwNTc4JGo1NiRsMCRoNTc5NzYzMDg.*_ga_PXJXREL86H*czE3NzI1MzA1NzUkbzIwJGcwJHQxNzcyNTMwNTc4JGo1NyRsMCRoMA"
      },
      "phone": "+34 91 602 01 82",
      "email": "clienteslaley@aranzadilaley.es"
    }
  },
  "system_messages": {
    "_ANALYSING_DOCUMENTS_": "Analizando documentos",
    "_ANALYSING_QUERY_": "Analizando la pregunta",
    "_ANALYSING_SOURCES_": "Analizando fuentes",
    "_FETCHING_SIMILAR_DOCUMENTS_": "Buscando fuentes",
    "_FETCHING_LAW_DOCUMENTS_": "Buscando referencias legales",
    "_FETCHING_PREPATORY_WORK_DOCUMENTS_": "Buscando trabajos preparatorios",
    "_FETCHING_LITERATURE_DOCUMENTS_": "Buscando referencias bibliográficas",
    "_GENERATING_ANSWER_": "Generando una respuesta"
  },
  "document_tag_tooltip": "Pincha o escribe \"@\" para referenciar un documento de la base de datos",
  "input_character_limit_reached": "Se alcanzó el número máximo de caracteres",
  "user_carousels": {
    "dismiss": "Continuar",
    "carousels": {
      "onboarding": {
        "title": "Bienvenido a Allegra",
        "read_more_url": "",
        "screens": {
          "welcome": {
            "description": "La combinación del lenguaje cotidiano y el modelo de IA de Aranzadi LA LEY facilita tu búsqueda de información jurídica",
            "header": "Encuentra respuestas a tus preguntas legales"
          },
          "credibility": {
            "description": "El conocimiento humano potencia la tecnología de IA, y siempre tendrás la última palabra",
            "header": "Basado en el contenido de Aranzadi LA LEY"
          },
          "security": {
            "description": "Allegra protege tus datos mediante una estricta gestión de datos",
            "header": "Tus datos están bien protegidos"
          },
          "feedback": {
            "description": "Evalúa las respuestas generadas y dinos cómo podemos mejorar",
            "header": "Ayúdanos a mejorar Allegra con tus comentarios"
          }
        }
      }
    },
    "read_more_label": "Leer más"
  },
  "header": {
    "goto_main_content": "Ir al contenido principal"
  },
  "user_menu": {
    "logout": "Cerrar sesión",
    "go_to_platform": "Aranzadi LA LEY",
    "redirect_to_login": "Actualizar acceso",
    "theme_selector": {
      "appearance": "Apariencia",
      "theme": {
        "dark": "Oscuro",
        "light": "Claro",
        "system": "Sistema"
      }
    },
    "language_selector": {
      "content": "contenido",
      "header": "Idioma",
      "languages": {
        "da": "Danés",
        "es": "Español",
        "fr": "Francés",
        "sv": "Sueco",
        "no": "Bokmål (noruego)",
        "nn": "Nynorsk (noruego)"
      }
    },
    "go_to_flow": "Allegra Flow",
    "learn_about_flow": "Saber más",
    "badge": "Nuevo"
  },
  "platform_name": "Allegra",
  "document_analysis": {
    "select_document_analysis_mode": "Selecciona una opción de análisis",
    "hero_banner": {
      "intro": "Aranzadi LA LEY presenta",
      "headline": "Analizador de documentos Allegra",
      "description": "Nuestros expertos han desarrollado capacidades de análisis únicas que te ayudan a transformar documentos complejos y cuestiones legales sofisticadas en soluciones concretas."
    },
    "file_upload_header": {
      "description": "Sube tu contrato para comenzar",
      "title": "Revisión de contrato"
    },
    "use_prompt_button": "Acceder",
    "see_example_button": "Ver ejemplo",
    "back_to_document_analysis_list": "Volver a análisis de documentos",
    "options": {
      "contract_review": {
        "title": "Analiza contratos",
        "description": "Obtén una revisión rápida cláusula por cláusula de tus contratos. Para cada cláusula obtendrás las fuentes relacionadas, los posibles riesgos clasificados por nivel (alto, medio o bajo) y sugerencias concretas. Además recibirás una evaluación interpretativa con recomendaciones precisas y las referencias jurídicas correspondientes.",
        "guide": "Además del documento puedes incorporar información adicional así como otras circunstancias relevantes que no figuren en el documento.",
        "example_text": "Aquí tienes un ejemplo de análisis. Te da una visión general de las respuestas de Allegra para que puedas evaluar si se adapta a tus necesidades.",
        "placeholder": "Añade información adicional"
      },
      "document_compliance": {
        "title": "Analiza políticas de cumplimiento",
        "description": "Analiza y compara tu política de cumplimiento. Además del documento puedes incorporar información adicional así como otras circunstancias relevantes que no figuren en el documento.",
        "guide": "Además del documento puedes incorporar información adicional así como otras circunstancias relevantes que no figuren en el documento.",
        "example_text": "",
        "placeholder": "Añade información adicional"
      },
      "argument_strengthener": {
        "title": "Refuerza tus argumentos",
        "description": "Obtén una revisión rápida de tus argumentos utilizando fuentes jurídicas relevantes para fortalecerlos. Obtendrás argumentos más sólidos respaldados con la información precisa de Aranzadi LA LEY.",
        "guide": "Además del documento puedes incorporar información adicional así como otras circunstancias relevantes que no figuren en el documento.",
        "example_text": "",
        "placeholder": "Añade información adicional"
      },
      "weakness_finder": {
        "title": "Detecta inconsistencias",
        "description": "Identifica los puntos donde la argumentación es débil o insuficiente. Analiza los argumentos de la contraparte y propone contraargumentos, posibles enfoques estratégicos y te ayuda a formular planteamientos más sólidos con referencias concretas. Obtendrás una estrategia para aprovechar las debilidades de la contraparte, documentada y lista para usar.",
        "guide": "Además del documento puedes incorporar información adicional así como otras circunstancias relevantes que no figuren en el documento.",
        "example_text": "",
        "placeholder": "Añade información adicional"
      }
    }
  },
  "workspace_promo_banner": {
    "text": "Empieza a trabajar con Allegra Flow",
    "link": "Saber más",
    "badge": "Nuevo"
  },
  "prompt_suggestions": {
    "kaila": {
      "title": "Encuentra respuestas a tus consultas legales",
      "description": "Inspírate con estas sugerencias",
      "templates": [
        {
          "category": "book-section",
          "prompt": "¿Con qué argumentos puedo defender que mi cliente, que ha recibido prestación de IMV por error, no tiene que reintegrar la cantidad?",
          "sample": "¿Con qué argumentos puedo defender que mi cliente, que ha recibido prestación de IMV por error, no tiene que reintegrar la cantidad?"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "Haz un email breve con consejos para al gerente de una empresa cliente ante una visita de un Inspector de Trabajo",
          "sample": "Haz un email breve con consejos para al gerente de una empresa cliente ante una visita de un Inspector de Trabajo"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "¿Existe limitación en el precio en la venta de solares destinados a viviendas de protección oficial en Cataluña?",
          "sample": "¿Existe limitación en el precio en la venta de solares destinados a viviendas de protección oficial en Cataluña?"
        },
        {
          "category": "book-section",
          "prompt": "Hazme un resumen de los requisitos necesarios para implantar un sistema de acceso al trabajo con datos biométricos teniendo en cuenta el RGPD",
          "sample": "Hazme un resumen de los requisitos necesarios para implantar un sistema de acceso al trabajo con datos biométricos teniendo en cuenta el RGPD"
        }
      ]
    },
    "kfc": {
      "title": "Encuentra respuestas a tus consultas legales",
      "description": "Inspírate con estas sugerencias",
      "templates": [
        {
          "category": "book-section",
          "prompt": "¿Puede un beneficiario de asistencia social que cumple los requisitos para vacaciones tomar primero 14 días de vacaciones con prestación y luego 14 días sin prestación?",
          "sample": "¿Puede un beneficiario de asistencia social que cumple los requisitos para vacaciones tomar primero 14 días de vacaciones con prestación y luego 14 días sin prestación?"
        },
        {
          "category": "book-section",
          "prompt": "¿Los ejercicios de estiramiento para mantener funciones básicas como vestirse, bañarse, etc., son una prestación según el artículo 83 o el artículo 86 de la Ley de Servicios Sociales?",
          "sample": "¿Los ejercicios de estiramiento para mantener funciones básicas como vestirse, bañarse, etc., son una prestación según el artículo 83 o el artículo 86 de la Ley de Servicios Sociales?"
        },
        {
          "category": "book-section",
          "prompt": "¿Qué aspectos debe tener especialmente en cuenta el ayuntamiento al decidir sobre el cierre de una vía privada?",
          "sample": "¿Qué aspectos debe tener especialmente en cuenta el ayuntamiento al decidir sobre el cierre de una vía privada?"
        },
        {
          "category": "book-section",
          "prompt": "¿Qué requisitos existen para el tratamiento de datos personales en la transmisión manual de información sobre personas individuales de un ayuntamiento a otra autoridad administrativa?",
          "sample": "¿Qué requisitos existen para el tratamiento de datos personales en la transmisión manual de información sobre personas individuales de un ayuntamiento a otra autoridad administrativa?"
        }
      ]
    },
    "replay": {
      "title": "Encuentra respuestas a tus consultas legales",
      "description": "Inspírate con estas sugerencias",
      "templates": [
        {
          "category": "scale-unbalanced-flip",
          "prompt": "example",
          "sample": "Example"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "error",
          "sample": "Error"
        }
      ]
    },
    "mock": {
      "title": "Encuentra respuestas a tus consultas legales",
      "description": "Inspírate con estas sugerencias",
      "templates": [
        {
          "category": "scale-unbalanced-flip",
          "prompt": "test",
          "sample": "test"
        },
        {
          "category": "book-section",
          "prompt": "gfm",
          "sample": "Git flavoured markdown"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "invalid",
          "sample": "Invalid response"
        },
        {
          "category": "book-section",
          "prompt": "markdown",
          "sample": "markdown"
        },
        {
          "category": "siren-on",
          "prompt": "markdown-invalid",
          "sample": "Invalid & malformed markdown"
        },
        {
          "category": "siren-on",
          "prompt": "markdown-error",
          "sample": "Component that throws an uncaught exception"
        },
        {
          "category": "table",
          "prompt": "table",
          "sample": "table"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "details",
          "sample": "details"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "stressTest",
          "sample": "stress test"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "markdownAndInlineReferences",
          "sample": "Inline references after markdown elements"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "refsList",
          "sample": "Inline references in list"
        },
        {
          "category": "book-section",
          "prompt": "new-refsList",
          "sample": "New reference mdx format"
        }
      ]
    }
  },
  "errors": {
    "footer": {
      "title": "Estamos aquí para ayudarte",
      "description": "Si ha encontrado algún problema, póngase en contacto con el servicio de atención al cliente en el {{telephone}} o en {{email}}",
      "email": "clienteslaley@aranzadilaley.es",
      "telephone": "+34 91 602 01 82"
    },
    "auth": {
      "no_session": {
        "title": "",
        "subtitle": "",
        "description": ""
      },
      "default": {
        "title": "No hemos podido iniciar tu sesión",
        "subtitle": "",
        "description": "Se ha producido un error durante el inicio de sesión. Por favor, inténtelo de nuevo o póngase en contacto con el servicio de atención al cliente si el problema persiste."
      }
    }
  },
  "close_service_message_banner": "Cerrar mensaje",
  "upload_modal": {
    "attachment_limit_exceeded_warning": "Has alcanzado el límite de {{attachmentLimit}} documentos por pregunta. Elimina un documento para poder subir otro.",
    "close_modal_button_label": "Hecho",
    "description": "Puedes subir hasta {{attachmentLimit}} documentos, dependiendo de su tamaño.",
    "done_button": "Hecho",
    "file_browser": {
      "browse_files": "Examinar",
      "description": "Tipos de archivo admitidos: .pdf y .docx",
      "header": "Haz clic aquí para subir, o arrastra y suelta"
    },
    "capacity_indicator": {
      "attachment_count": "{{count}}/{{limit}} Documentos",
      "tooltip": "Cada documento ocupa un porcentaje de tu límite total de carga, basado en el número de palabras, no en el tamaño del archivo. Los documentos largos ocupan por tanto más espacio, por lo que puedes alcanzar el 100 % antes de haber subido 10 archivos.",
      "used_capacity": "espacio utilizado"
    },
    "file_upload_button_tooltip": "Subir archivos",
    "header": "Subir archivos",
    "open_modal_button": "Subir archivos",
    "onboarding_tooltip": "Novedad: ahora puedes subir hasta 10 documentos por pregunta.",
    "reinsurance_label": "Tus archivos están cifrados",
    "reinsurance_tooltip": "Karnov Group protege la confidencialidad de todos los datos de sus clientes, incluida la información que introducen, los datos que se generan y los documentos que suben. Para ello utiliza un cifrado sólido que cumple con las normas aplicables."
  },
  "prompt_input_with_document_references": {
    "add_document_references_button": {
      "label": "Referenciar documentos",
      "tooltip": "Haz clic para referenciar un documento",
      "onboarding_tooltip": "Hemos hecho más fácil hacer referencia a los documentos."
    }
  },
  "document_references_modal": {
    "description": "Al referenciar documentos puedes obtener una respuesta más precisa",
    "close_modal_button_label": "Finalizar",
    "document_references_count": "Referencias seleccionadas ({{count}})",
    "done_button": "Finalizar",
    "empty_state": {
      "header": "Incorpora una fuente en la respuesta",
      "description": "Puedes usar esta función si quieres asegurarte de que se incluyan una o varias fuentes en la respuesta de Alegra."
    },
    "header": "Referenciar documentos",
    "remove_document_reference_button": "Eliminar referencia",
    "search": {
      "fetching_suggestions": "Recuperando documentos...",
      "input_label": "Buscar un documento",
      "input_placeholder": "Escribe aquí el nombre del documento",
      "error": {
        "description": "Intenta volver a cargar la página",
        "title": "Algo salió mal"
      },
      "empty_search": {
        "description": "Escribe un título o referencia válido, o ve a Aranzadi LA LEY para encontrar el documento.",
        "kfc_disclaimer": "Allegra ya tiene acceso a tus documentos locales, por lo que no es necesario etiquetarlos.",
        "title": "No se encontraron documentos"
      }
    }
  },
  "message_resources": {
    "remove_message_resource": {
      "attachment": "Eliminar documento",
      "document_reference": "Eliminar referencia"
    },
    "open_modal": {
      "attachment": "Ver documentos",
      "document_reference": "Ver referencias"
    },
    "placeholder": {
      "label": {
        "attachment": "{{count}} archivos subidos",
        "document_reference": "{{count}} documentos referenciados"
      },
      "tooltip": {
        "attachment": "Ver todos los archivos subidos",
        "document_reference": "Ver todos los documentos referenciados"
      }
    }
  },
  "search": {
    "clear_input": "Borrar texto de búsqueda",
    "placeholder": "Buscar..."
  }
}
